import { makeStyles } from "@mui/styles";
export const useStyles = makeStyles(() => ({
  mainContainer: {
    background: "#F5F8FF",
    minHeight: "100%",
    minWidth: "100%",
    bottom: "auto",
  },
  root: {
    padding: "20px 20px 0px 300px",
    marginTop: "70px",
  },
  tableDiv: {
    border: "1px",
  },
  fabAdd: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  addBtn: {
    fontSize: 14,
    color: "#333333",
    border: "1px solid #D5D8DE",
    fontFamily: "Cairo",
    fontWeight: "400",
  },
  saveBtn: {
    background: "#3D63E6",
    color: "#ffff",
    "&:hover": {
      background: "#3D63E6",
    },
    fontFamily: "Cairo",
    fontWeight: 700,
    fontSize: "16px",
    width: "160px",
    height: "50px",
  },
  cancelBtn: {
    color: "#3D63E6",
    borderColor: "#3D63E6",
    "&:hover": {
      borderColor: "#3D63E6",
    },
    fontFamily: "Cairo",
    fontWeight: 700,
    fontSize: "16px",
    width: "160px",
    height: "50px",
  },
  btnContainer: {
    display: "flex",
    alignItems: "flex-end",
  },
  headerModal: {
    color: "#012497",
    fontFamily: "Cairo",
    fontWeight: "800",
    fontSize: "24px",
  },
  modalContainer: {
    padding: "25px",
  },
  addModal: {
    position: "absolute",
    background: "#F5F8FF",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    boxShadow: "0",
    zIndex: "9999",
    display: "flex",
  },
  textFieldStyle: {
    width: "200px",
    marginRight: 15,
    backgroundColor: "white",
    "& label": {
      marginBottom: "15px",
    },
    "& .css-jd1zyo-MuiSelect-select-MuiInputBase-input-MuiInput-input.MuiSelect-select":
      {
        background: "white",
        border: "1px solid #D1D1D1",
        borderRadius: "5px",
        height: "30px",
        marginTop: "8px",
        padding: "5px",
      },
    "& .css-175axk8-MuiInputBase-root-MuiInput-root:before, & .css-175axk8-MuiInputBase-root-MuiInput-root:after":
      {
        border: "none",
      },
  },
  deleteModal: {
    position: "absolute",
    background: "#FFFFFF",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    border: "0px",
    boxShadow: "0",
    zIndex: "9999",
    width: "410px",
    height: "230px",
  },
  deleteTypo: {
    color: "#2A3333",
    fontFamily: "Cairo",
    fontWeight: "400",
    fontSize: "16px",
  },
  dataTableDiv: {
    maxHeight: "calc(100vh - 210px)",
    maxWidth: "100%",
    overflowY: "auto",
    overflowX: "auto",
    marginTop: "0px",
    border: "1px solid #C6C9CA",
    background: "#F5F8FF",
  },
}));
